import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Swiper } from "swiper/react";

import { theme, transientOptions } from "shared/lib/styles";

import IconArrow from "./icon-arrow.svg";

type FigureProps = {
  $aspectRatio: string;
  $aspectRatioDesktopUp: string;
  $aspectRatioTabletUp: string;
};

export const Figure = styled.figure<FigureProps>`
  inline-size: 100%;
  block-size: 100%;

  picture {
    ${props => css`
      aspect-ratio: ${props.$aspectRatio};

      ${theme.breakpoints.up("tablet")} {
        ${props.$aspectRatioTabletUp &&
        css`
          aspect-ratio: ${props.$aspectRatioTabletUp};
        `};
      }

      ${theme.breakpoints.up("desktop")} {
        ${props.$aspectRatioDesktopUp &&
        css`
          aspect-ratio: ${props.$aspectRatioDesktopUp};
        `};
      }
    `}
  }
`;

export const StyledFigcaption = styled.figcaption`
  margin-block-start: 8px;

  color: #999999;
  font-weight: 400;
  font-size: 12px;
`;

type SwiperFigureProps = FigureProps;

export const StyledSwiper = styled(Swiper)<SwiperFigureProps>`
  inline-size: 100%;

  overflow: hidden;

  ${props => css`
    aspect-ratio: ${props.$aspectRatio};

    ${theme.breakpoints.up("tablet")} {
      ${props.$aspectRatioTabletUp &&
      css`
        aspect-ratio: ${props.$aspectRatioTabletUp};
      `};
    }

    ${theme.breakpoints.up("desktop")} {
      ${props.$aspectRatioDesktopUp &&
      css`
        aspect-ratio: ${props.$aspectRatioDesktopUp};
      `};
    }
  `}

  .swiper-slide {
    overflow: hidden;
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
`;

export const Controls = styled.div`
  display: flex;
  gap: 13px;
  justify-content: center;
  align-items: center;

  padding-block-start: 8px;

  ${theme.breakpoints.up("tablet")} {
    justify-content: flex-end;

    padding-block-start: 6px;
  }
`;

export const DotsContainer = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const Dot = styled.button<{ $isActive: boolean }>`
  inline-size: 6px;
  block-size: 6px;
  padding: 0;

  border: none;
  border-radius: ${props => (props.$isActive ? "3px" : "50%")};

  background: ${props => (props.$isActive ? "#333" : "#ccc")};

  cursor: pointer;

  transition:
    border-radius 0.3s ease,
    background 0.3s ease;
`;

type ArrowProps = {
  $isDisabled?: boolean;
};

const Arrow = styled(IconArrow, { ...transientOptions })<ArrowProps>`
  display: none;

  cursor: pointer;

  opacity: ${props => (props.$isDisabled ? 0.3 : 1)};

  pointer-events: ${props => (props.$isDisabled ? "none" : "auto")};

  transition: opacity 0.2s ease;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const ArrowNext = styled(Arrow)``;

export const ArrowPrevious = styled(Arrow)`
  transform: rotate(180deg);
`;
